import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export var DisableNotificationIcon = function DisableNotificationIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("circle", {
      cx: "20",
      cy: "20",
      r: "20",
      fill: "#686868"
    }), /*#__PURE__*/_jsx("path", {
      d: "M28 27.69L15.84 15.14L13.27 12.49L12 13.76L14.8 16.56V16.57C14.28 17.56 14 18.73 14 19.99V24.99L12 26.99V27.99H25.73L27.73 29.99L29 28.72L28 27.69ZM20 31C21.11 31 22 30.11 22 29H18C18 30.11 18.89 31 20 31ZM26 23.68V20C26 16.92 24.36 14.36 21.5 13.68V13C21.5 12.17 20.83 11.5 20 11.5C19.17 11.5 18.5 12.17 18.5 13V13.68C18.35 13.71 18.21 13.76 18.08 13.8C17.98 13.83 17.88 13.87 17.78 13.91H17.77C17.76 13.91 17.76 13.91 17.75 13.92C17.52 14.01 17.29 14.12 17.07 14.23C17.07 14.23 17.06 14.23 17.06 14.24L26 23.68Z",
      fill: "white"
    })]
  });
};